import { useTranslation } from "react-i18next";
import { ChatAttachButton, ChatShell } from "@/zapi-frontend/shared/ui/chat";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { hasEditAccess } from "@/zapi-frontend/shared/utils/permissions";

// Leo has no Add files button, so it is shown only while a regular chat is expected.
export function ChatPanelLoading({ leo = false }: { leo?: boolean }) {
  const { t } = useTranslation(["common", "projectHome"]);
  const { role, accessMode } = useMeStore();
  const title = leo ? t("projectHome:leo.title") : t("projectHome:chat.title");
  return (
    <ChatShell
      appearance="leo"
      className="h-full w-full"
      bodyClassName="p-0 overflow-hidden"
      data-testid="chat-panel-loading"
      title={title}
      placeholder={leo ? t("projectHome:leo.placeholderAnything") : t("loadingChapter")}
      input=""
      onInputChange={() => undefined}
      onSubmit={() => undefined}
      isLoading
      loadingLabel={t("loadingMessages")}
      controlsLeft={
        !leo && hasEditAccess(role, accessMode) ? <ChatAttachButton label={t("addFiles")} disabled /> : undefined
      }
      onClear={() => undefined}
      canClear={false}
      clearConfirm={{ menuLabel: t("clear") }}
      dockCloseLabel={leo ? t("projectHome:leo.hide") : t("projectHome:chat.hide")}
    />
  );
}
